export const primary = "#003c71";
export const primaryLight = "#52C7B8";
export const secondary = "#008755";
export const textDefault = "#000A12";
export const highlight = "#00E0BF"
export const neutral800 = "#4F5B62";

export const orange500 = "#a4691a"
